<div class="h-100">
  <finxone-web-frontend-pisp-banks-listing
    class="h-100"
    [widgetConfigData]="widgetConfig"
    [contentStyle]="contentStyle"
    [textContentStyle]="textContentStyle"
    [searchIconStyle]="searchIconStyle"
    [setSupportedInstitutions]="supportedInstitutions"
    [widgetName]="widgetName"
    [isApiInProgress]="isApiInProgress"
    (selectedBankEmit)="handleSelection($event)"
  ></finxone-web-frontend-pisp-banks-listing>
</div>
